<template>
  <div>
    <v-container fluid class="full-height">
      <v-row v-if="!conferenceWtw" style="background-color: #ceefed">
        <v-col :cols="checkRole == 'แพทย์' ? 8 : 12">
          <v-card style="min-height: 100vh" class="card-detail ml-1">
            <v-card-title class="justify-space-between pa-4">
              <v-btn icon large elevation="2" @click="back()">
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>

              <v-span
                class="font-20"
                style="color: #00a99d; font-weight: bold; text-align: center"
                >ผู้ป่วย: {{ detailConference.patient_name }}</v-span
              >
              <v-btn v-if="sender && !closeCapture" icon disabled small
                ><v-icon>mdi-clear</v-icon></v-btn
              >
              <v-btn v-if="!sender && !closeCapture" icon disabled small
                ><v-icon>mdi-clear</v-icon></v-btn
              >
              <v-btn
                v-if="!sender && closeCapture"
                @click="captureScreen()"
                color="#00a99d"
                dark
                style="border-radius: 8px"
              >
                <v-icon class="mr-2">mdi-monitor-screenshot</v-icon>
                screenshot</v-btn
              >
            </v-card-title>
            <v-card-text>
              <iframe
                class="iframe"
                allow="camera *; microphone; display-capture"
                :src="
                  detailConference.conference_url
                    ? detailConference.conference_url
                    : detailConference.data.conference_url
                "
                frameBorder="0"
                scrolling="no"
              ></iframe>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="4" v-show="checkRole == 'แพทย์'">
          <v-card class="card-detail mr-1 ml-0" style="min-height: 100vh">
            <v-tabs
              color="#00a99d"
              class="elevation-0"
              v-model="currentItem"
              show-arrows
              grow
              center-active
            >
              <v-tabs-slider></v-tabs-slider>

              <v-tab class="tab pb-2"> บันทึกการรักษา </v-tab>
              <v-tab class="tab pb-2" v-show="selectDrug"> สั่งรายการยา </v-tab>
            </v-tabs>
            <div class="my-4">
              <v-tabs-items v-model="currentItem" class="full-height-tab">
                <v-tab-item eager
                  ><Tab1MedicalRecords
                    ref="form1"
                    :item="screenShot"
                    @chooseDrug="getChoose"
                  ></Tab1MedicalRecords>
                  <v-col cols="12">
                    <div class="d-flex justify-end pt-3">
                      <v-btn
                        width="30%"
                        dark
                        color="#00a99d"
                        @click="currentItem = 1"
                        v-if="selectDrug"
                        >ถัดไป
                      </v-btn>
                      <v-btn
                        width="30%"
                        dark
                        color="#00a99d"
                        @click="save"
                        v-else
                        >บันทึก</v-btn
                      >
                    </div>
                  </v-col>
                </v-tab-item>
                <v-tab-item eager
                  ><Tab3DrugRecords ref="form2"></Tab3DrugRecords
                  ><v-col cols="12">
                    <div class="d-flex justify-end pt-3">
                      <v-btn
                        class="mr-2"
                        width="30%"
                        outlined
                        color="#00a99d"
                        @click="currentItem = 0"
                        >ย้อนกลับ</v-btn
                      >
                      <v-btn width="30%" dark color="#00a99d" @click="save"
                        >บันทึก</v-btn
                      >
                    </div>
                  </v-col></v-tab-item
                ></v-tabs-items
              >
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-else style="background-color: #ceefed">
        <v-col :cols="sender ? '12' : '8'">
          <v-card style="min-height: 104vh" class="card-detail ml-1">
            <v-card-title class="justify-space-between pa-4">
              <v-btn icon large elevation="2" @click="back">
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>

              <v-span
                class="font-20"
                style="color: #00a99d; font-weight: bold; text-align: center"
                >ผู้ป่วย: {{ detailConferenceWtw.patient_name }}</v-span
              >
              <v-btn v-if="sender && closeCapture" icon disabled small
                ><v-icon>mdi-clear</v-icon></v-btn
              >
              <v-btn v-if="!sender && !closeCapture" icon disabled small
                ><v-icon>mdi-clear</v-icon></v-btn
              >
              <v-btn
                v-if="!sender && closeCapture"
                @click="captureScreen()"
                color="#00a99d"
                dark
                style="border-radius: 8px"
              >
                <v-icon class="mr-2">mdi-monitor-screenshot</v-icon>
                screenshot</v-btn
              >
            </v-card-title>
            <v-card-text>
              <div ref="iframeContainer" style="width: 100%; height: 50vh">
                <Conference
                  style="height: 90vh"
                  :item="detailConferenceWtw.conference_url"
                  :back="isBackConference"
                  :sender="sender"
                  :key="rerenderKey"
                  @data-ending-conference="handleDataFromConference"
                ></Conference>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col v-if="!sender" cols="4" v-show="checkRole == 'แพทย์'">
          <v-card class="card-detail mr-1 ml-0" style="min-height: 100vh">
            <v-tabs
              color="#00a99d"
              class="elevation-0"
              v-model="currentItem"
              show-arrows
              grow
              center-active
            >
              <v-tabs-slider></v-tabs-slider>

              <v-tab class="tab pb-2"> บันทึกการรักษา </v-tab>
              <v-tab class="tab pb-2" v-show="selectDrug"> สั่งรายการยา </v-tab>
            </v-tabs>
            <div class="my-4">
              <v-tabs-items v-model="currentItem" class="full-height-tab">
                <v-tab-item eager
                  ><Tab1MedicalRecords
                    ref="form1"
                    :item="screenShot"
                    @chooseDrug="getChoose"
                  ></Tab1MedicalRecords>
                  <v-col cols="12">
                    <div class="d-flex justify-end pt-3">
                      <v-btn
                        width="30%"
                        dark
                        color="#00a99d"
                        @click="currentItem = 1"
                        v-if="selectDrug"
                        >ถัดไป
                      </v-btn>
                      <v-btn
                        width="30%"
                        dark
                        color="#00a99d"
                        @click="save"
                        v-else
                        >บันทึก</v-btn
                      >
                    </div>
                  </v-col>
                </v-tab-item>
                <v-tab-item eager
                  ><Tab3DrugRecords ref="form2"></Tab3DrugRecords
                  ><v-col cols="12">
                    <div class="d-flex justify-end pt-3">
                      <v-btn
                        class="mr-2"
                        width="30%"
                        outlined
                        color="#00a99d"
                        @click="currentItem = 0"
                        >ย้อนกลับ</v-btn
                      >
                      <v-btn width="30%" dark color="#00a99d" @click="save"
                        >บันทึก</v-btn
                      >
                    </div>
                  </v-col></v-tab-item
                ></v-tabs-items
              >
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import { EventBus } from "../EventBus";
import Tab1MedicalRecords from "../views/TabConference/Tab1MedicalRecords.vue";
import Tab3DrugRecords from "../views/TabConference/Tab3DrugRecords.vue";
import Conference from "@/views/conference/CreateConference.vue";
// import html2canvas from "html2canvas";
export default {
  components: { Tab1MedicalRecords, Tab3DrugRecords, Conference },
  data: () => ({
    tab: ["บันทึกการรักษา", "บันทึกสุขภาพ"],
    currentItem: 0,
    selectDrug: true,
    channel_name: "",
    detailConferenceWtw: {},
    conferenceWtw: false,
    sender: false,
    screenshot: null,
    screenShot: null,
    screenWidth: window.innerWidth,
    screenHeight: window.innerHeight,
    closeCapture: true,
    textDocterId: sessionStorage.oneId,
    isBackConference: false,
    rerenderKey: 0,
  }),
  watch: {
    "detailConferenceWtw.conference_url"(newVal, oldVal) {
      console.log("conference_url changed from", oldVal, "to", newVal);
    },
  },
  computed: {
    ...mapState(["detailConference", "isCapture"]),
    ...mapMutations(["setStatusReady"]),
    almost_mobile() {
      if (this.$vuetify.breakpoint.width < 450) {
        return true;
      } else {
        return false;
      }
    },
    checkRole() {
      return sessionStorage.role_name;
    },
  },
  sockets: {
    connect() {
      console.log("connect sockets io");
    },
    endingConference(res) {
      console.log("🚀 ~ endingConference ~ res:", res);
      if (res.one_id.sender_oneid == this.textDocterId && this.sender) {
        this.back();
      }
    },
  },
  created() {
    this.rerenderKey++;
    this.isBackConference = false;
    if (
      this.$route.query.patient_name &&
      this.$route.query.token &&
      this.$route.query.conference_id
    ) {
      this.conferenceWtw = true;
      this.detailConferenceWtw.patient_name = this.$route.query.patient_name;
      this.detailConferenceWtw.conference_url = this.$route.query.token;
      this.detailConferenceWtw._id = this.$route.query.conference_id;
    }
    if (this.$route.query.sender) {
      this.sender = true;
    }
  },
  async mounted() {
    window.addEventListener("resize", this.updateScreenSize);
    window.addEventListener("storage", this.handleStorageChange);
    // setTimeout(() => {
    //   const params = new URLSearchParams();
    //   var hisId;
    //   if (this.conferenceWtw) {
    //     hisId = this.detailConferenceWtw._id;
    //   } else {
    //     hisId = this.detailConference.data.his_id || this.detailConference._id;
    //   }
    //   params.append("his_id", hisId);
    //   // console.log("🚀 ~ CheckTimeConference ~ params:", params);
    //   this.axios
    //     .get(
    //       `${process.env.VUE_APP_BACKEND_URL}/v1/conferences/get_history_conference`,
    //       {
    //         params,
    //       }
    //     )
    //     .then((res) => {
    //       // console.log("res", res);
    //       this.channel_name = res.data.data.data.data[0].channel_name;
    //       console.log("🚀 ~ .then ~ this.channel_name:", this.channel_name);
    //     });
    // }, 10 * 1000);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateScreenSize);
  },
  methods: {
    ...mapMutations(["setDetailConference", "setCaptureScreen"]),
    handleStorageChange(event) {
      if (event.key === "isCapture") {
        const newValue = event.newValue === "true";
        console.log("🚀 ~ handleStorageChange ~ newValue:", newValue);
        this.closeCapture = newValue;
      }
    },
    updateScreenSize() {
      this.screenWidth = window.innerWidth;
      this.screenHeight = window.innerHeight;
    },
    async save() {
      try {
        const {
          $refs: {
            form1: {
              _data: {
                congenital_disease,
                current_symptoms,
                marjor_symptoms,
                medical_record,
                radioGroup,
              } = {},
            } = {},
            form2: { _data: { itemDrug } = {} } = {},
          } = {},
          detailConference: { patient_name, ref1 },
        } = this;
        let drug_list = [];

        // console.log(
        //   "🚀 ~ file: Conference.vue:114 ~ save ~ $refs:",

        //   itemDrug,
        //   patient_name
        // );
        itemDrug.forEach((element) => {
          if (element.price != "") {
            drug_list.push({
              ...element.list_drug,
              total: element.sum,
              count: element.count,
            });
          }
        });
        var hisId;
        if (this.conferenceWtw) {
          hisId = this.detailConferenceWtw._id;
        } else {
          hisId =
            this.detailConference.data.his_id || this.detailConference._id;
        }
        const payload = {
          congenital_disease,
          current_symptoms,
          marjor_symptoms,
          medical_record,
          screenShot: this.screenShot,
          radioGroup,
          drug_list,
          patient_name: this.conferenceWtw
            ? this.detailConferenceWtw.patient_name
            : patient_name,
          biz_id: sessionStorage.biz_id,
          his_id: hisId,
          patient_id: ref1 ? ref1 : "",
          staff_id: sessionStorage.oneId,
          staff_name: sessionStorage.accountName,
        };
        this.$swal
          .fire({
            title: "บันทึกการรักษา",
            text: "บันทึกการรักษาใช่หรือไม่",
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonColor: "#00a99d",
            confirmButtonText: "ตกลง",
            denyButtonText: `ยกเลิก`,
          })
          .then(async (result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              const { data: { result } = {} } = await this.axios.post(
                `${process.env.VUE_APP_BACKEND_URL}/v1/diagnostic-histories`,
                payload
              );
              if (result == "success") {
                this.$swal.fire({
                  icon: "success",
                  title: "บันทึกการรักษาสำเร็จ",
                  showConfirmButton: false,
                  timer: 1000,
                });
                // this.back();
                this.endConference();
                this.backConference();
                if (payload.his_id.includes("WTW")) {
                  let data = {
                    one_id: sessionStorage.oneId,
                    biz_id: sessionStorage.biz_id,
                    role: sessionStorage.role_name,
                    status: true,
                  };
                  this.axios
                    .put(
                      `${process.env.VUE_APP_BACKEND_URL}/v1/staffs/status`,
                      data
                    )
                    .then((res) => {
                      if (res.data) {
                        let statusReady = true;
                        this.setStatusReady(statusReady);
                      }
                    });
                }
                EventBus.$emit("statusCall");
                this.$router.push({ path: "doctorList" });
                this.$socket.connect();
              }
            } else if (result.isDenied) {
              // Swal.fire("Changes are not saved", "", "info");
            }
            this.setCaptureScreen(true);
          });
      } catch (err) {
        console.log("🚀 ~ save ~ err:", err);
      }
    },
    endConference() {
      try {
        var body = {
          channel_name: this.channel_name,
        };
        this.axios
          .post(`https://meet.manageai.co.th/api/v1/calling/ending`, body)
          .then((res) => {
            console.log("🚀 ~ .then ~ res:", res);
          });
      } catch (error) {
        console.error();
      }
    },
    backConference() {
      const params = new URLSearchParams();
      var hisId;
      if (this.conferenceWtw) {
        hisId = this.detailConferenceWtw._id;
      } else {
        hisId = this.detailConference.data.his_id || this.detailConference._id;
      }
      params.append("his_id", hisId);
      this.axios
        .get(`${process.env.VUE_APP_BACKEND_URL}/v1/conferences/hang_up`, {
          params,
        })
        .then((res) => {
          console.log("🚀 ~ .then ~ res", res);
          if (res) {
            console.log("close Conference success");
          }
        });
      this.setCaptureScreen(true);
    },
    getChoose(choose) {
      this.selectDrug = choose;
    },
    back(text) {
      try {
        if (text == "ending") {
          this.isBackConference = true;
        }
        if (this.sender) {
          this.backConference();
        }
        let data = {
          one_id: sessionStorage.oneId,
          biz_id: sessionStorage.biz_id,
          role: sessionStorage.role_name,
          status: true,
        };
        this.axios
          .put(`${process.env.VUE_APP_BACKEND_URL}/v1/staffs/status`, data)
          .then((res) => {
            if (res.data) {
              let statusReady = true;
              this.setStatusReady(statusReady);
            }
          });
       
        if (this.conferenceWtw) {
          this.$router.push({
            name: "DoctorList",
          });
        } else {
           this.$router.go(-1);
        }
        this.setCaptureScreen(true);
      } catch (err) {
        console.log("🚀 ~ err:", err);
      }
    },
    // captureScreen() {
    //   const captureArea = this.$refs.iframeContainer;
    //   console.log("🚀 ~ this.$nextTick ~ captureArea:", captureArea);
    //   if (!captureArea) {
    //     return;
    //   }
    //   html2canvas(captureArea)
    //     .then((canvas) => {
    //       this.screenshot = canvas.toDataURL("image/png");
    //       console.log("🚀 ~ .then ~ this.screenshot:", this.screenshot);
    //     })
    //     .catch((error) => {
    //       console.error("Screenshot error:", error);
    //     });
    // },
    // async captureScreen() {
    //   const element = this.$refs.iframeContainer; // ดึง element ที่ต้องการแคป
    //   console.log("🚀 ~ captureScreen ~ element:", element);
    //   const canvas = await html2canvas(element, { useCORS: true }); // สร้างภาพจาก element
    //   this.screenshot = canvas.toDataURL("image/png"); // แปลงเป็น base64 image
    // },

    // async captureScreen() {
    //   const key = "60c488";
    //   const url = this.detailConferenceWtw.conference_url;
    //   const dimension = "1024x768";
    //   const delay = "5000"
    //   console.log("🚀 ~ captureScreen ~ url:", url);
    //   const screenshotUrl = `https://api.screenshotmachine.com?key=${key}&url=${url}&dimension=${dimension}&delay=${delay}`;
    //   const response = await fetch(screenshotUrl);
    //   console.log("🚀 ~ captureScreen ~ response:", response.blob());
    //   this.screenshot = response.blob();
    // },

    // async captureScreen() {
    //   try {
    //     const stream = await navigator.mediaDevices.getDisplayMedia({
    //       video: { mediaSource: "screen" },
    //     });

    //     const video = document.createElement("video");
    //     video.srcObject = stream;
    //     video.play();

    //     // รอให้ video โหลดเสร็จ
    //     await new Promise((resolve) => (video.onloadedmetadata = resolve));

    //     // สร้าง Canvas เพื่อจับภาพจาก video
    //     const canvas = document.createElement("canvas");
    //     canvas.width = video.videoWidth * 10;
    //     canvas.height = video.videoHeight * 10;
    //     const ctx = canvas.getContext("2d");

    //     // วาดภาพจาก video ไปยัง canvas
    //     const iframe = this.$refs.iframeContainer.getBoundingClientRect();
    //     ctx.drawImage(video, iframe.left, iframe.top, iframe.width, iframe.height, 0, 0, canvas.width, canvas.height);

    //     // แปลง canvas เป็น base64
    //     this.screenshot = canvas.toDataURL("image/png");
    //     console.log("🚀 ~ captureScreen ~ this.screenshot:", this.screenshot)

    //     // หยุด video stream หลังจากจับภาพเสร็จ
    //     stream.getTracks().forEach((track) => track.stop());
    //   } catch (error) {
    //     console.error("Screenshot error:", error);
    //   }
    // },

    async captureScreen() {
      try {
        const stream = await navigator.mediaDevices.getDisplayMedia({
          video: true,
        });

        const video = document.createElement("video");
        video.srcObject = stream;

        video.onloadedmetadata = () => {
          video.play();
          setTimeout(() => {
            const canvas = document.createElement("canvas");
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
            this.screenshot = canvas.toDataURL("image/png");
            stream.getTracks().forEach((track) => track.stop());
            // this.cropImage(canvas);
            this.screenShot = canvas.toDataURL("image/png");
          }, 1000);
        };
      } catch (error) {
        console.error("Error capturing screen:", error);
      }
    },
    cropImage(originalCanvas) {
      // image ขนาดแสดงเฉพาะของผู้ป่วย
      // let cropX = 30;
      // let cropY = 400;
      // let cropWidth = 1200;
      // let cropHeight = 550;
      // if (this.screenWidth > 1707) {
      //   cropHeight = 600
      //   cropY = 350
      // }
      // else if (this.screenWidth < 1550) {
      //   cropHeight = 520
      //   cropY = 420
      // }
      // image ขนาดแสดงทั้งหน้าจอ
      let cropX = 30;
      let cropY = 250;
      let cropWidth = 1200;
      let cropHeight = 780;
      if (this.screenWidth >= 1707) {
        cropY = 250;
        cropX = 50;
        cropWidth = 1190;
      } else if (this.screenWidth >= 2048) {
        cropY = 100;
      } else if (this.screenWidth >= 3072) {
        cropY = 200;
      } else if (this.screenWidth <= 1550) {
        cropY = 280;
        cropHeight = 750;
        cropX = 50;
        cropWidth = 1180;
      }
      const croppedCanvas = document.createElement("canvas");
      croppedCanvas.width = cropWidth;
      croppedCanvas.height = cropHeight;
      const croppedCtx = croppedCanvas.getContext("2d");
      croppedCtx.drawImage(
        originalCanvas,
        cropX,
        cropY,
        cropWidth,
        cropHeight,
        0,
        0,
        cropWidth,
        cropHeight
      );
      this.screenShot = croppedCanvas.toDataURL("image/png");
      console.log("🚀 ~ cropImage ~ this.screenShot:", this.screenShot);
    },
    handleDataFromConference(data) {
      if (data && this.sender) {
        this.back("ending");
      }
    },
  },
};
</script>
<style scoped>
.card-detail {
  border-radius: 20px;
}
.v-tabs-items.full-height-tab .v-window-item {
  height: calc(85vh); /* Adjust 270px to suits your needs */
  overflow-y: auto;
}
.iframe {
  width: 100%;
  height: 90vh;
}
@media only screen and (max-width: 1264px) {
  .iframe {
    width: 100%;
    height: 50vh;
  }
}

@media only screen and (max-width: 960px) {
  .iframe {
    width: 100%;
    height: 50vh;
  }
}

@media only screen and (max-width: 360px) {
  .iframe {
    width: 100%;
    height: 30vh;
  }
}

.screenshot-img {
  width: 100%;
  max-width: 600px;
  height: 300px;
  border: 2px solid #000;
  border-radius: 10px;
}
</style>
